var playButton = document.getElementById("play_button");
var playIcon = document.querySelector('#play_button span')
const video = document.querySelector('.video');

if(document.querySelector('.blockVideo')){
  playButton.addEventListener("click", function() {
    if (video.paused == true) {
      video.play();
      playIcon.classList.add('play');
      playIcon.classList.remove('pause');
  
    } else {
      video.pause();
      playIcon.classList.add('pause');
      playIcon.classList.remove('play');
    }
  });
  }